import { showErrorSrc176Evid102 } from '@wix/error-handler-core/@wix/bi-logger-os-data/v2';
import { withoutDefaults } from '../util/withoutDefaults';
export function reportShowErrorBi(errorHandler, params) {
  var _errorAccessor$errorH;
  const {
    message,
    action,
    errorAccessor
  } = params;
  const {
    biLogger,
    translations
  } = errorHandler;
  biLogger.report(withoutDefaults(showErrorSrc176Evid102)({
    session_id: (_errorAccessor$errorH = errorAccessor.errorHandlerState) == null ? void 0 : _errorAccessor$errorH.sessionId,
    displayed_message: message,
    displayed_action: action == null ? void 0 : action.text,
    action_was_provided: String((action == null ? void 0 : action.onClick) != null),
    isEn: translations.i18n.language === 'en'
  }));
}
//# sourceMappingURL=reportShowErrorBi.js.map